import React, { useState, useEffect } from 'react';
import { useParams, Link, useHistory } from 'react-router-dom';
import Flipbook from '../components/Flipbook';
import { getPublicacion } from '../services/publicacionesService';
import { getInstitution } from '../config/institutionConfig';

const MagazinePage = () => {
  const { categoryId, magazineId } = useParams();
  const history = useHistory();
  const [publicacion, setPublicacion] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const institution = getInstitution();

  useEffect(() => {
    getPublicacion(categoryId, magazineId)
      .then(setPublicacion)
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  }, [categoryId, magazineId]);

  if (loading) {
    return (
      <div className="min-h-screen bg-white flex flex-col items-center justify-center p-8">
        <p className="text-gray-400">Cargando publicación...</p>
      </div>
    );
  }

  if (!publicacion || error) {
    return (
      <div className="min-h-screen bg-white flex flex-col items-center justify-center p-8">
        <div className="max-w-md text-center">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Publicación no encontrada
          </h1>
          <p className="text-gray-600 mb-6">
            La publicación que buscas no está disponible o no existe.
          </p>
          <Link
            to="/"
            className="inline-block px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            Volver al inicio
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="h-screen overflow-hidden flex flex-col bg-gray-800 md:bg-white md:min-h-screen md:h-auto md:overflow-visible">
      {/* Header mejorado y profesional */}
      <div className="flex-1 flex flex-col items-center md:justify-center p-0 md:p-4 lg:p-8 md:bg-white min-h-0">
        <header
          className="flex-shrink-0 app-header magazine-header"
          style={{
            maxWidth: '1200px',
            marginBottom: '0'
          }}
        >
          <div style={{ 
            padding: '16px 24px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}>
            {/* Logo y título juntos */}
            <div style={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: '12px'
            }}>
              {/* Botón volver a categoría */}
              {/* <button
                onClick={() => history.push(`/${categoryId}`)}
                style={{
                  background: 'rgba(255, 255, 255, 0.1)',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  borderRadius: '8px',
                  padding: '8px 12px',
                  color: '#ffffff',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                  fontSize: '14px',
                  fontWeight: '500',
                  transition: 'all 0.2s',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = 'rgba(255, 255, 255, 0.15)';
                  e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.3)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
                  e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.2)';
                }}
                title="Volver a la categoría"
              >
                <svg width="16" height="16" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z" clipRule="evenodd" />
                </svg>
                {category.name}
              </button> */}

              {/* Logo con tamaño fijo */}
              <div style={{ flexShrink: 0 }}>
                <img
                  src={`${process.env.PUBLIC_URL}${institution.logo}`}
                  alt={`Logo ${institution.shortName}`}
                  className="app-logo"
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              </div>
              {/* Título mejorado */}
              <div>
                <h1 
                  style={{
                    color: '#ffffff',
                    fontSize: '24px',
                    fontWeight: '700',
                    margin: '0',
                    letterSpacing: '0.5px',
                    textShadow: '0 2px 4px rgba(0,0,0,0.2)'
                  }}
                >
                  {publicacion.titulo}
                </h1>
                <p style={{
                  color: '#94a3b8',
                  fontSize: '13px',
                  margin: '2px 0 0 0',
                  fontWeight: '400'
                }}>
                  {publicacion.descripcion || 'Visualiza el documento de manera interactiva'}
                </p>
              </div>
            </div>
            
            {/* Indicador opcional del lado derecho */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              color: '#94a3b8',
              fontSize: '14px'
            }}>
              <svg width="20" height="20" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9 2a2 2 0 00-2 2v8a2 2 0 002 2h6a2 2 0 002-2V6.414A2 2 0 0016.414 5L14 2.586A2 2 0 0012.586 2H9z" />
                <path d="M3 8a2 2 0 012-2v10h8a2 2 0 01-2 2H5a2 2 0 01-2-2V8z" />
              </svg>
            </div>
          </div>
        </header>
        
        {/* Reader principal */}
        <Flipbook pdfUrl={`${process.env.PUBLIC_URL}${publicacion.rutaArchivo}`} />
      </div>
    </div>
  );
};

export default MagazinePage;
